import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { WithStyles, Theme, createStyles, SnackbarContent } from '@material-ui/core';
import OrganizationForm from '../../organization/components/OrganizationForm';
import InfoIcon from '@material-ui/icons/Info';

const styles = (theme: Theme) =>
  createStyles({
    tcModel: {
      marginTop: theme.spacing.unit * 9,
      marginLeft: theme.spacing.unit * 2,
      marginRight: theme.spacing.unit * 2,
      padding: theme.spacing.unit * 3,
    },
    icon: {
      fontSize: 20,
      opacity: 0.9,
      marginRight: theme.spacing.unit,
    },
    info: {
      backgroundColor: '#1976d2',
      width: '100%',
      maxWidth: 'none',
      marginBottom: theme.spacing.unit * 4,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
  });

interface IProps extends WithStyles<typeof styles> {
  callback?: () => void
}

class BillingAdressForm extends React.PureComponent<IProps> {
  public render() {
    const { classes } = this.props;

    return (
      <div className={classes.tcModel}>
        <SnackbarContent
          className={classes.info}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              <InfoIcon className={classes.icon} />
              A billing address is required! To continue, please check your organization details below and make sure a billing address is provided.
            </span>
          }
        />
        <OrganizationForm callback={this.props.callback}/>
      </div>
    );
  }
}

export default withStyles(styles)(BillingAdressForm);



// WEBPACK FOOTER //
// ./src/modules/core/pages/BillingAdressForm.tsx